import {
  SUBJECT_VOCABULARY_BY_VERTICAL,
  statusTone,
  type EventAttendee,
  type SubjectStatus,
} from '@ni/shared';

const TONE_ORDER = ['in', 'candidate', 'known', 'watched', 'closed'];

/**
 * **The vertical's statuses, most engaged first**: by tone (in, candidate,
 * known, watched, closed), then the vertical's own order within a tone.
 */
export function statusesByTone(vertical: string): SubjectStatus[] {
  const words = SUBJECT_VOCABULARY_BY_VERTICAL[vertical]?.statuses ?? [];
  const rank = (status: SubjectStatus) => TONE_ORDER.indexOf(statusTone(vertical, status));
  return [...words].sort((a, b) => rank(a) - rank(b) || words.indexOf(a) - words.indexOf(b));
}

/** The tracked people the attendee list leads to, once each, with their status where known. */
export function trackedAttendees(
  rows: readonly EventAttendee[],
): { entityId: string; name: string; status: SubjectStatus | null }[] {
  const seen = new Set<string>();
  return rows.flatMap((row) => {
    const record = row.on_record;
    if (!record?.tracked || seen.has(record.entity_id)) return [];
    seen.add(record.entity_id);
    return [
      {
        entityId: record.entity_id,
        name: record.display_name,
        status: record.status,
      },
    ];
  });
}
